import {
  Box,
  MainContainer,
  MainContainerFullWidth
} from "../../styles/basicStyles";
import { FC } from "react";
import { useTranslation } from "next-i18next";
import { CaseStudy } from "../../models/work";
import { colors } from "../../styles/colors";
import ContactBanner from "../../components/views/contactBanner";
import Description from "./components/description";
import Testimonies from "./components/testimonies";
import InfoBar from "./components/infoBar";
import Numbers from "./components/numbers";
import Filters from "./components/filters";
import Banner from "./components/banner";
import Blocks from "./components/blocks";
import Metatags from "../../components/metatags";

interface Props {
  data: CaseStudy;
}

const WorkDetail: FC<Props> = ({ data }) => {
  const { i18n: { language } } = useTranslation();

  return (
    <>
      <Metatags
        title={data.meta_title && data.meta_title[language]}
        description={data.meta_description && data.meta_description[language]}
        keywords={data.meta_keywords && data.meta_keywords[language]}
        image={data.image?.url}
      />
      <Box fDirection="column">
        <Banner
          imageDesktop={data?.image_detail?.url}
          imageMobile={data?.image_detail_mobile?.url}
          logo={data?.company?.logo_detail?.url}
          bgColorDesktop={data?.image_detail_color ? data?.image_detail_color : "transparent"}
          bgColorMobile={data?.image_detail_mobile_color ? data?.image_detail_mobile_color : "transparent" }
          titleColor={data?.color_title ? data?.color_title : colors.white}
          titleDetail={data?.title_detail && data?.title_detail[language]}
          subtitle={data?.subtitle && data?.subtitle[language]}
          androidLink={data?.android ? data?.android_link : undefined}
          iosLink={data?.ios ? data?.ios_link : undefined}
          websiteLink={data?.website ? data?.website_link : undefined}
        />
        <InfoBar
          titleDetail={data?.title_detail ? data?.title_detail[language] : ""}
          subtitle={data?.subtitle ? data?.subtitle[language] : ""}
          bgColorDesktop={data?.image_detail_color ? data?.image_detail_color : colors.white}
          tabBarTitleColor={data?.color_bar_title ? data?.color_bar_title : colors.white}
          tabBarSubtitleColor={data?.color_subtitle ? data?.color_subtitle : colors.white}
        />
        <MainContainer>
          <Filters 
            year={data?.year}
            services={data?.services}
            industries={data?.industries}
            technologies={data?.technologies}
            productTypes={data?.product_types}
          />
        </MainContainer>
        {
          data?.description && data?.description[language] &&
          <MainContainer>
            <Box fAlign="center" fJustify="center">
              <Description description={data?.description[language]} />
            </Box>
          </MainContainer>
        }
        {
          data?.blocks?.map((block, index) =>
            <Blocks
              key={index}
              type={block?.type}
              blockBarColor={data?.color ? data.color : colors?.purple}
              title={block?.title && block?.title[language]}
              description={block?.description && block?.description[language]}
              image={block?.image?.url}
              bgColor={block?.background_color ? block?.background_color : "transparent"}
              position={block.background_position ? block.background_position : 1}
              orientation={block?.text_orientation}
              animation={block.file?._id && `${process.env.NEXT_PUBLIC_API_FILES}${block.file?._id}`}
              video={block.file?._id && `${process.env.NEXT_PUBLIC_API_FILES}${block.file?._id}`}
              maxWidth={block?.video_max_width ? block?.video_max_width / 16 : undefined}
              paddingBottom={block?.padding_bottom}
              paddingTop={block?.padding_top}
            />
          )
        }
        {data?.numbers && <Numbers data={data?.numbers} />}
        {
          data?.testimony_image?.url &&
          data?.testimony_name &&
          data?.testimony_job &&
          data?.testimony &&
          data?.company?.logo_detail?.url &&
          <Testimonies
            image={data?.testimony_image?.url}
            author={data?.testimony_name}
            role={data?.testimony_job[language]}
            testimony={data?.testimony[language]}
            companyLogo={data?.company?.logo_detail?.url}
          />
        }
        <MainContainerFullWidth>
          <ContactBanner />
        </MainContainerFullWidth>
      </Box>
    </>
  );
};

export default WorkDetail;
